export default {
	bookingTimeout() {
		return process.env.bookingTimeoutInMinute * 60;
	},
	maxFileUploadSizeInMb() {
		return process.env.maxFileUploadSizeInMb;
	},
};
